export default "__VITE_ASSET__DzbeFB21__"